module.exports = __webpack_public_path__ + "static/aloopdrop-9dc6fcb5bd64373af7ddc88f524547cc.png";